module.exports = "<h1>Logout</h1>\n"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/log-out/log-out.component.html
// module id = ../../../../../src/app/log-out/log-out.component.html
// module chunks = main